// polyfill only stable features - ES and web standards:
import 'core-js/stable';
import 'temporal-polyfill/global';

import '@/lib/tour/config';
